import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocalStorageManager } from '../../../utils/local-storage-manager/local-storage-manager.utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-delete',
  templateUrl: './modal-delete.component.html',
  styleUrls: ['./modal-delete.component.css']
})
export class ModalDeleteComponent {

  @Output() confirm = new EventEmitter<boolean>();
  @Input() modalId: string = "app-modal-delete";
  @Input() info: ModalDeleteInfo =  {
    title: 'CONFIRMAR',
    body: '¿Estas seguro que deseas eliminarlo?',
    body2 : "",
    confirmText: 'Si',
    cancelText: 'Cancelar'
  };

  constructor(private translate: TranslateService) {
    let lang = LocalStorageManager.lang;
    this.translate.use(lang!);
  }

  isDarkmode: boolean = LocalStorageManager.isDarkmode;

  setConfirmation(confirm: boolean) {
    this.confirm.emit(confirm);
  }
}

export interface ModalDeleteInfo {
  title: string;
  body: string;
  body2?: string;
  confirmText: string;
  cancelText: string;
}